import { SUPPORTED_SHAPES } from "@mixitone/util";
import { useState } from "react";
import { ColorDot } from "./ColorDot";

interface Props {
  value: string;
  onChange: (shape: string) => void;
  color?: string;
}

export const ShapeSelector: React.FC<Props> = ({ value, onChange, color = "#2196F3" }) => {
  const [selectedShape, setSelectedShape] = useState(value || "circle");

  const handleShapeSelect = (shape: string) => {
    setSelectedShape(shape);
    onChange(shape);
  };

  return (
    <div className="flex flex-wrap gap-2">
      {SUPPORTED_SHAPES.map((shape) => (
        <button
          key={shape}
          className={`p-1 border-2 rounded ${
            selectedShape === shape ? "border-blue-500" : "border-transparent"
          }`}
          onClick={() => handleShapeSelect(shape)}
          type="button"
          aria-label={`Select ${shape} shape`}
        >
          <ColorDot color={color} size={30} shape={shape}>
            A
          </ColorDot>
        </button>
      ))}
    </div>
  );
};
